import React, { memo } from 'react'
import { Box } from '@mui/material'

import { FORGOT_PASSWORD_URL, SIGNUP_URL } from '../../constants/navigation'
import { LOGIN_PROFILE_DISPATCH } from '../../store/reducers/auth/login'
import { ERROR_TEXT } from '../../constants/messages'
import customConfig from 'customConfig'
import { FormHead } from '../../auth/components/form-head'
import { FormDivider } from '../../auth/components/form-divider'
import TextLink from '../text/TextLink'
import SocialMedia from '../socialMedia/SocialMedia'
import SubmitButton from '../shared/button/SubmitButton'
import CustomForm from '../shared/inputs/CustomForm'
import CustomTextField from '../shared/inputs/CustomTextField'
import LoginLinkText from '../shared/loginLinkText/LoginLinkText'
import PageTitle from '../shared/pageTitle/PageTitle'

const Login = ({
  onFormSubmit,
  dispatchAction,
  onResendVerification,
  loginProfile: { error, success, email, password, isProcessing },
  onSocialMediaLogin,
  t
}) => {
  const resendVerifyEmailLink = (error) => {
    if (error && error === ERROR_TEXT.EMAIL_VERIFICATION_FAILED) {
      return (
        <>
          {t(error)}{' '}
          <TextLink
            label={t('common.resend-verification-email')}
            onClick={onResendVerification}
            variant='caption'
          />
        </>
      )
    }
    return typeof error === 'boolean' ? error : t(error)
  }
  const pageTitle = t(customConfig.loginPageTitle)

  return (
    <>
      <PageTitle title={pageTitle} />
      <FormHead
        title={t(customConfig.loginPageDescLabel)}
        description={
          <>
            {t('login.no-account-yet')}
            <TextLink label={t('sign-up.sign-up')} to={SIGNUP_URL} />
          </>
        }
        sx={{ textAlign: { xs: 'center', md: 'left' } }}
      />
      <SocialMedia onSocialMediaLogin={onSocialMediaLogin} />
      <FormDivider label={t('common.or')} />
      <CustomForm onFormSubmit={onFormSubmit}>
        <Box sx={{ gap: 3, display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            id='email'
            type='email'
            label={t('common.email-address')}
            error={resendVerifyEmailLink(buildEmailErrors(error))}
            success={t(success[LOGIN_PROFILE_DISPATCH.EMAIL])}
            value={email}
            onChange={(value) =>
              dispatchAction(LOGIN_PROFILE_DISPATCH.EMAIL, value)
            }
          />
          <CustomTextField
            id='password'
            label={t('common.password')}
            eyePassword
            error={t(error[LOGIN_PROFILE_DISPATCH.PASSWORD])}
            value={password}
            onChange={(value) =>
              dispatchAction(LOGIN_PROFILE_DISPATCH.PASSWORD, value)
            }
          />
          <SubmitButton
            label={t('login.log-in')}
            loading={isProcessing}
            fullWidth
          />
          <LoginLinkText
            label={t('login.forgot-your-password')}
            actionLabel={t(customConfig.resetItLabel)}
            to={FORGOT_PASSWORD_URL}
          />
        </Box>
      </CustomForm>
    </>
  )
}

export default memo(Login)

const buildEmailErrors = (error) => {
  const defaultError = error[LOGIN_PROFILE_DISPATCH.EMAIL]
  if (defaultError) {
    return defaultError
  }
}
